import React from 'react';

export const ClockIcon: React.FC = () => {
    return <span style={{marginTop: '2px'}}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.5 8C0.5 3.86 3.8525 0.5 7.9925 0.5C12.14 0.5 15.5 3.86 15.5 8C15.5 12.14 12.14 15.5 7.9925 15.5C3.8525 15.5 0.5 12.14 0.5 8ZM7.25 4.25H8.375V8.1875L11.75 10.19L11.1875 11.1125L7.25 8.75V4.25Z" fill="#F5AE0A" />
        </svg>

    </span>
}
